import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import machine, { types as machineTypes } from "./modules/machine";
import companyReport, {
  types as companyReportTypes,
} from "./modules/company-report";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    auth,
    [machineTypes.MODULE]: machine,
    [companyReportTypes.STORE_MODULE]: companyReport,
  },
  strict: debug,
});
